module.exports = __webpack_public_path__ + "static/img/ban-3.afc9c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-3.png
// module id = 2AvD
// module chunks = 0